import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InvoicePaymentModel } from 'app/models/invoice-payment.model';
import { SurveyMetaModel } from 'app/core/models/survey-question-response.model';

@Component({
    selector: 'app-invoice-payment',
    templateUrl: './invoice-payment.component.html',
    styleUrls: ['./invoice-payment.component.css'],
    standalone: false
})
export class InvoicePaymentComponent implements OnInit {
    public invoice_payment_model: InvoicePaymentModel;
    public survey_enabled = false;
    public survey_question_id = '';
    public survey_question_text ='';
    public survey_meta: Array<SurveyMetaModel> =new Array<SurveyMetaModel>() ;
    constructor(private route: ActivatedRoute) { }

  ngOnInit() {
      this.route.data.subscribe(({ invoice_payment_model,survey_question_model }) => {
     this.invoice_payment_model = invoice_payment_model;
     this.survey_question_id = survey_question_model.id;
     this.survey_question_text =survey_question_model.question_text;

     this.survey_enabled =invoice_payment_model.survey_enabled;
     this.survey_meta.push({
      meta_type: 'payment',
      id : this.invoice_payment_model.id
     },{
      meta_type: 'invoice',
      id : this.route.snapshot.paramMap.get('invoice_id')
     });
});
  }

}
